export default function trackEvent(...args) {
  if (window.ga) {
    window.ga('anteroga.send', 'event', ...args);
  } else {
    console.log('[TrackEvent] GA is not loaded, but here\'s the event data:', ...args);
  }
}
